import PropTypes from 'prop-types';

export const UserUploadPropTypes = {
	dataTable: PropTypes.shape({
		actions: PropTypes.arrayOf(
			PropTypes.shape({
				Type: PropTypes.string.isRequired,
				onChangedHandler: PropTypes.func,
				Header: PropTypes.shape({
					Checked: PropTypes.bool,
					Key: PropTypes.string,
					onChangedHandler: PropTypes.func,
				}),
			})
		),
		errorMessage: PropTypes.string,
		headers: PropTypes.arrayOf(
			PropTypes.shape({
				Value: PropTypes.string,
				props: PropTypes.shape({
					onSortChange: PropTypes.func,
					sort: PropTypes.number,
				}),
			})
		).isRequired,
		iconLegend: PropTypes.arrayOf(
			PropTypes.shape({
				BindTo: PropTypes.number.isRequired,
				ValuePrimary: PropTypes.string.isRequired,
				ValueSecondary: PropTypes.string,
			})
		),
		label: PropTypes.string,
		rows: PropTypes.arrayOf(
			PropTypes.shape({
				ActionCells: PropTypes.arrayOf(
					PropTypes.shape({
						BindTo: PropTypes.number.isRequired,
						Checked: PropTypes.bool.isRequired,
						Key: PropTypes.string.isRequired,
						Text: PropTypes.string,
					})
				),
				Cells: PropTypes.objectOf(
					PropTypes.shape({
						Value: PropTypes.string,
						Validation: PropTypes.shape({
							Key: PropTypes.string.isRequired,
							memberToValidateKey: PropTypes.string,
							Value: PropTypes.shape({
								ErrorMessage: PropTypes.string,
							}),
						}),
						props: PropTypes.shape({
							alignEnd: PropTypes.bool,
							alignMiddle: PropTypes.bool,
							alignStart: PropTypes.bool,
							children: PropTypes.node,
							isNumeric: PropTypes.bool,
						}),
					})
				),
				Key: PropTypes.string.isRequired,
				props: PropTypes.shape({
					activated: PropTypes.bool,
					selected: PropTypes.bool,
				}),
			})
		).isRequired,
	}).isRequired,
	errorMessage: PropTypes.string,
	isLoading: PropTypes.bool,
	label: PropTypes.string,
	onUpload: PropTypes.func.isRequired,
};
